module.exports = __webpack_public_path__ + "img/img_01.4a810d1d.png";